import React from 'react';

import {
  LINE_ITEM_DAY,
  LINE_ITEM_LONG_TERM_DISCOUNT,
  LINE_ITEM_PARTNERSHIP_DISCOUNT,
  LINE_ITEM_PROMO_DISCOUNT, LINE_ITEM_SERVICE_FEE,
  LINE_ITEM_EVENING_DISCOUNT
} from '../../../util/types';
import ServiceFeeItem from './ServiceFeeItem';
import ListingsItem from './ListingsItem/ListingsItem';

const OriginalOrderItems = ({ confirmLineItems, listings, intl }) => {
    const serviceFeeLineItem = confirmLineItems.filter(item => item?.code === LINE_ITEM_SERVICE_FEE);

    if (serviceFeeLineItem.length) {
      return (
        <ServiceFeeItem
          serviceFeeLineItem={serviceFeeLineItem}
          intl={intl}
          idMessage="OrderInfo.subTotal"
        />
      );
    }

    const originProducts = confirmLineItems.filter(item => item?.code === LINE_ITEM_DAY);
    const originDiscount = confirmLineItems.find(
      item => item?.code === LINE_ITEM_LONG_TERM_DISCOUNT,
    );
    const originEveningDiscount = confirmLineItems.find(
      item => item?.code === LINE_ITEM_EVENING_DISCOUNT,
    );
    const originPromoDiscount = confirmLineItems.find(
      item => item?.code === LINE_ITEM_PROMO_DISCOUNT,
    );

    const originPartnershipDiscount = confirmLineItems.find(item => item?.code === LINE_ITEM_PARTNERSHIP_DISCOUNT);

    const sum = originProducts.reduce(
      (sum, currentValue) => sum + currentValue.lineTotal.amount,
      0
    );
    const currency = originProducts[0].lineTotal.currency;
    const subTotalWithDiscount = originDiscount ? sum + originDiscount.lineTotal.amount  : sum;
    const subTotalWithEveningDiscount = originEveningDiscount ? subTotalWithDiscount + originEveningDiscount.lineTotal.amount : subTotalWithDiscount;
    const amountSubTotal = (originPromoDiscount || originPartnershipDiscount)
      ? subTotalWithEveningDiscount + (originPromoDiscount?.lineTotal?.amount || 0) + (originPartnershipDiscount?.lineTotal?.amount || 0)
      : subTotalWithEveningDiscount;

    const subTotal = { amount: amountSubTotal, currency };

    return (
      <ListingsItem
        key="confirm"
        products={originProducts}
        listings={listings}
        intl={intl}
        longTermDiscount={originDiscount}
        eveningDiscount={originEveningDiscount}
        promoDiscount={originPromoDiscount}
        partnershipDiscount={originPartnershipDiscount}
        money={subTotal}
        idMessage="OrderInfo.subTotal"
      />
    );
}

export default OriginalOrderItems;
